export class UnexpectedHttpResponseError extends Error {
  public name: string;
  public statusCode: number;
  public statusText: string;

  constructor(message: string, status: number, statusText: string) {
    super(message);
    this.statusCode = status;
    this.statusText = statusText;
    this.name = "UnexpectedHttpResponseError";
  }
}
